var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('vs-button',{attrs:{"color":"success","type":"gradient","icon":"edit","radius":""},on:{"click":function($event){return _vm.guncelle()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }